
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pawnId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deploymentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"as"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"uberadmin"},{"kind":"EnumValue","value":"learner"}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentProgress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"deploymentId"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"deploymentId"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"pawnId"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"pawnId"}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"devTags"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"poise_p_average"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"poise_o_average"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"poise_i_average"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"poise_s_average"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"poise_e_average"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"restful_sleep"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nutritious_food"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"exercise"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"not_sedentary"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"artistic_activities"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sense_of_purpose"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"supportive_people"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"time_management"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"achieve_goals"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"supervisor_communication"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stimulate_mind"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pursue_interests"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"help_others"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"life_story"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"principles_values"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"satisfying_relationships"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"beneficial_feedback"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"annoyance_awareness"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"acknowledge_success"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"resolve_conflicts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"painful_emotions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"feel_calm"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"effective_coping"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"manage_emotions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enjoy_present"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":1186}};
    doc.loc.source = {"body":"query($pawnId: Int, $deploymentId: Int) {\n    flows(as: [uberadmin, learner]) {\n        assignmentProgress(deploymentId: [$deploymentId], pawnId: [$pawnId]) {\n            devTags {\n                poise_p_average\n                poise_o_average\n                poise_i_average\n                poise_s_average\n                poise_e_average\n                restful_sleep\n                nutritious_food\n                exercise\n                not_sedentary\n                artistic_activities\n                sense_of_purpose\n                supportive_people\n                time_management\n                achieve_goals\n                supervisor_communication\n                stimulate_mind\n                pursue_interests\n                help_others\n                life_story\n                principles_values\n                satisfying_relationships\n                beneficial_feedback\n                annoyance_awareness\n                acknowledge_success\n                resolve_conflicts\n                painful_emotions\n                feel_calm\n                effective_coping\n                manage_emotions\n                enjoy_present\n            }\n        }\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
